export default __webpack_public_path__ + "images/77.27b6cba.png";